// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input--selection-controls[data-v-7a3605f0]{margin-top:5px;padding-top:0}", ""]);
// Exports
module.exports = exports;
